import styled from 'styled-components'
import Breakpoint from '../../utils/breakpoint'

const {mobile, desk} = Breakpoint
interface LabelProps {
  readonly langCode: string
}
const otherLangsMap = ['ja']

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  gap: 2px;
  margin-bottom: 2px;
  @media (max-width: ${mobile}px) {
    flex-direction: column;
  }
`

export const MainContent = styled.div`
  flex: 0 1 50%;
  @media (max-width: ${mobile}px) {
    margin-bottom: 1px;
  }
`

interface ContainerProps {
  dataSrc: any
}

export const FiguresWrapper = styled.div``

export const Inner = styled.article<LabelProps>`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  &.left__inner {
    color: #000;
    @media (max-width: 767px) {
    }
  }
  &.right__inner {
    color: #fff;
    left: 25%;
    @media (max-width: 767px) {
    }
    .right__inner__title {
    }
  }
  span {
    font-size: 14px;
    font-family: 'Open Sans', sans-serif;
    line-height: 1;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
  div {
    line-height: 1;
    font-size: 40px;
    @media (max-width: 767px) {
      line-height: 1;
      font-size: 28.8px;
    }
  }
`
